module.exports = __webpack_public_path__ + "static/media/discord_manage.6ffb0e04.png";